import { queryOptions } from '@tanstack/react-query';

import { campaignsApi } from '../apis/campaigns-api';

export const campaignKeys = {
  all: () => ['campaigns'] as const,
  lists: () => [...campaignKeys.all(), 'list'] as const,
  list: () =>
    queryOptions({
      queryKey: campaignKeys.lists(),
      queryFn: () => campaignsApi.getAll(),
    }),
  details: () => [...campaignKeys.all(), 'detail'] as const,
  detail: (id: number) =>
    queryOptions({
      queryKey: [...campaignKeys.details(), id],
      queryFn: () => campaignsApi.getOne(id),
      enabled: id > 0,
    }),
};

export default campaignKeys;
